// extracted by mini-css-extract-plugin
export var buttons = "ConfirmModal-module--buttons--3Jmoc";
export var container = "ConfirmModal-module--container--DG11m";
export var welcomeContent = "ConfirmModal-module--welcomeContent--tanFL";